import { AppLink } from '@/global/components/AppLink'

import {
  INSTITUTIONAL_URL,
  PLANS_COMPARISON_PDF_URL
} from '@/global/constants/routes'
import { dispatchEvent } from '@/global/utils/analytics-events'
import { ButtonClickedProps } from '@/global/utils/analytics-events/types/generalEvents'
import {
  ButtonType,
  EventName
} from '@/global/utils/analytics-events/types/common'

export interface LinkListProps {
  className?: string
}

export const LinkList = ({ className }: LinkListProps) => {
  const sendAnalyticEvent = (buttonType: ButtonType, buttonName: string) => {
    const buttonClickedEvent: ButtonClickedProps = {
      eventName: EventName.BUTTON_CLICKED,
      buttonType,
      buttonName
    }
    dispatchEvent(buttonClickedEvent)
  }
  return (
    <div
      className={`w-fit h-fit py-gl-spacing-04 desktop-short:py-gl-spacing-02 px-gl-spacing-06 desktop-short:px-gl-spacing-04 bg-sys-color-surface-container-idle rounded-gl-border-radius-md shadow-md flex gap-gl-spacing-03 items-center justify-center ${className}`}
    >
      <AppLink
        className='text-nowrap'
        as='link'
        variant='secondary'
        quiet
        size='small'
        href={INSTITUTIONAL_URL}
        target='_blank'
        onClick={() =>
          sendAnalyticEvent(ButtonType.NEW_PAGE, 'Atualizações de rede')
        }
      >
        Atualizações de rede
      </AppLink>

      <div className='w-1 h-1 bg-gl-color-shades-gray-20' />

      <AppLink
        className='text-nowrap'
        as='link'
        variant='secondary'
        quiet
        size='small'
        href={PLANS_COMPARISON_PDF_URL}
        target='_blank'
        onClick={() => sendAnalyticEvent(ButtonType.DOWNLOAD, 'Compare planos')}
      >
        Compare planos
      </AppLink>
    </div>
  )
}
